import { render } from "./IVRQueuesView.vue?vue&type=template&id=1080aed0&scoped=true"
import script from "./IVRQueuesView.vue?vue&type=script&lang=js"
export * from "./IVRQueuesView.vue?vue&type=script&lang=js"

import "./IVRQueuesView.vue?vue&type=style&index=0&id=1080aed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1080aed0"]])

export default __exports__